<div class="pfaq-page">

  <!-- Hero -->
  <div class="pfaq-hero">
    <div class="pfaq-hero__overlay"></div>
    <div class="pfaq-hero__content">
      <div class="pfaq-hero__eyebrow">Help Centre</div>
      <h1 class="pfaq-hero__title">Frequently Asked <span class="pfaq-hero__accent">Questions</span></h1>
      <ol class="pfaq-breadcrumb">
        <li><a [routerLink]="['/']"><i class="fa fa-home"></i></a></li>
        <li>FAQ</li>
        <li>FAQ for Parent / Teacher</li>
      </ol>
    </div>
  </div>

  <!-- Body -->
  <section class="pfaq-body">
    <div class="pfaq-container">

      <!-- Sidebar -->
      <aside class="pfaq-sidebar">
        <div class="pfaq-sidebar__header">Browse Topics</div>
        <ul class="pfaq-sidebar__list">
          <li><a [routerLink]="['/11plus-help-club/faq/general-faq']" class="pfaq-sidebar__link"><span class="pfaq-sidebar__dot"></span>General FAQ</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-parent-teacher']" class="pfaq-sidebar__link pfaq-sidebar__link--active"><span class="pfaq-sidebar__dot"></span>FAQ for Parent / Teacher</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-student']" class="pfaq-sidebar__link"><span class="pfaq-sidebar__dot"></span>FAQ for Student</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-volunteers']" class="pfaq-sidebar__link"><span class="pfaq-sidebar__dot"></span>FAQ For Volunteers</a></li>
          <li><a [routerLink]="['/11plus-help-club/faq/faq-for-community']" class="pfaq-sidebar__link"><span class="pfaq-sidebar__dot"></span>FAQ For Community</a></li>
        </ul>

        <div class="pfaq-cta-card">
          <div class="pfaq-cta-card__icon"><i class="fa fa-phone"></i></div>
          <h3 class="pfaq-cta-card__title">Still have questions?</h3>
          <p class="pfaq-cta-card__text">Our team is here to help you find the right support for your child.</p>
          <a [routerLink]="['/contact-us']" class="pfaq-cta-card__btn">Request a Call Back</a>
        </div>
      </aside>

      <!-- Content -->
      <div class="pfaq-content">
        <div class="pfaq-content__top">
          <h2 class="pfaq-content__title">FAQ for Parent / Teacher</h2>
          <div class="pfaq-content__rule"></div>
        </div>

        <div class="pfaq-accordion">

          <!-- Q1 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq1" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">How to book a session?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq1" class="pfaq-accordion__body content collapse in">
              <div class="pfaq-accordion__answer">
                <ol>
                  <li>Register / open account online at <a href="https://www.sehyog.co.uk" target="_blank">https://www.sehyog.co.uk</a></li>
                  <li>Login to your registered account</li>
                  <li>Click on SEHYOG logo – top left</li>
                  <li>Scroll down a little to 'upcoming events'</li>
                  <li>Click on the event you would like to attend</li>
                  <li>Look for the available 'Test Locations' and click on 'BOOK A SLOT' for the location you would want to attend the test.</li>
                  <li>Tick / Choose Student</li>
                  <li>Tick 'Request for Volunteer' and select a task from the drop down – if you are willing to help the club during the session</li>
                  <li>Click 'BOOK A SLOT' button</li>
                  <li>A hall ticket will be generated and email to you at your registered email id – verify your junk email box if it's not in the inbox</li>
                  <li>Print the hall ticket – it has venue address, Unique Registration Number (URN) and attendance QR code</li>
                  <li><strong>*IMPORTANT*</strong> Child must know his/her URN – this is unique and will stay same throughout your journey with Sehyog – child will need to clearly write it on the paper &amp; answer sheet</li>
                  <li>'Get In Touch' for further questions</li>
                  <li>Thank you !!!</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q2 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq2" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">How does 11plusHELPclub Operate?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq2" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>Please watch/read below video/documents to familiarise yourself with Sehyog and its process:</p>
                <ul>
                  <li>SEHYOG Open Day video: <a href="https://www.youtube.com/watch?v=lRZckmxvZOo" target="_blank">youtube.com/watch?v=lRZckmxvZOo</a></li>
                  <li>SEHYOG Open day presentation: <a href="https://drive.google.com/file/d/1-ET2MYFk4GXUaJH57piLnnt8lkgCVjwf/view?usp=drivesdk" target="_blank">Google Drive Presentation</a></li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Q3 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq3" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">How to make payment for the session bookings?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq3" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>There is no online payment facility available at the moment. Please pay at the door when your child will attend the session.</p>
              </div>
            </div>
          </div>

          <!-- Q4 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq4" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">When/How would I receive the result of the Topic/Full Mock Tests?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq4" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>A comprehensive Result Analysis Report (RAR) will be generated, reviewed and sent to your registered email id by Friday evening. If there is any delay, updates will be provided on SEHYOG website <a href="https://www.sehyog.co.uk" target="_blank">https://www.sehyog.co.uk</a></p>
              </div>
            </div>
          </div>

          <!-- Q5 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq5" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">What is Hernita Barnett grammar school exam structure?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq5" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>There are two parts:</p>
                <ul>
                  <li><strong>Round One:</strong> Verbal Reasoning, Non-Verbal Reasoning and English – GL Assessment</li>
                  <li><strong>Round Two:</strong> English and Mathematics Round 2 more or less like Essex CSSE exam on applied Maths &amp; English. In English, There are 2 writing tasks for 50 marks – it's long writing with many pages available for student to fill. One extended writing task other is questions from reading comprehension which is also a long write up.</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Q6 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq6" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">Understand student Rank displayed on the Result dashboard</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq6" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>The last column in the Result dashboard shows student Rank. You see <strong>x(y)</strong> — the number outside parenthesis is overall rank. The number in parenthesis tells the Group Rank. Group Rank is calculated based on School Year + Gender. The total number of children who gave the test are available in the pdf.</p>
              </div>
            </div>
          </div>

          <!-- Q7 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq7" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">Understand Percentile</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq7" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p>When you take a test and get a score of 87%, it tells you how many questions you've got right. However, your test score doesn't tell you how well you did compared to other people who took the test. Percentiles are values from 0 to 99 that tell you the percentage of tests with scores less than a particular score. If the percentile of your test score is 75, this means you've scored higher than 75% of the people who took the test.</p>
                <p><strong>Rank</strong> – rank among a group of children compared to their scores / numerical values, for example a group of 5 children score (out of 10) is as follows S1 4, S2 5, S3 5, S4 8, S5 2 — this means Rank1=S4, Rank2=S2, S3; Rank3=S1 &amp; Rank4=S5</p>
              </div>
            </div>
          </div>

          <!-- Q8 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq8" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">Policy – FREE sessions for NHS workers</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq8" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <div class="pfaq-highlight-box">
                  <p>Sehyog is offering FREE sessions for first child (single student) of NHS workers between Jun 2021 to Aug 2021.</p>
                  <p>This is just a small token of thanks for their heroic work during the ongoing pandemic situation due to Covid-19.</p>
                </div>
                <p class="pfaq-subheading">How can NHS workers claim this offer?</p>
                <ul>
                  <li>Goto sehyog.co.uk, sign up and add student. No sign up required if you're already an active member of Sehyog.</li>
                  <li>Send an email from your NHS email to <a href="mailto:info@sehyog.co.uk">info@sehyog.co.uk</a> with student URN (Unique Registration Number – located on your Sehyog.co.uk Dashboard)</li>
                  <li>Attach a signed copy of your NHS id in the email</li>
                  <li>Sehyog volunteers team will review your request and confirm FREE setup – sometimes response may take a little longer than expected due to backlog.</li>
                  <li>Once FREE setup completed, you may book future sessions FREE on sehyog.co.uk until Aug 2021.</li>
                </ul>
                <p>Join Telegram group chat for live support using below link –<br>
                  <a href="https://t.me/joinchat/SMnbMp4LZ9eEsm3h" target="_blank">https://t.me/joinchat/SMnbMp4LZ9eEsm3h</a>
                </p>
              </div>
            </div>
          </div>

          <!-- Q9 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq9" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">Kent Test Familiarisation Booklet</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq9" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <p><a href="https://www.kent.gov.uk/education-and-children/schools/grammar-schools/kent-grammar-school-entrance-test" target="_blank">Kent Grammar School Entrance Test</a></p>
              </div>
            </div>
          </div>

          <!-- Q10 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq10" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">How to access Live Meeting on eLearning Platform?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq10" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <ol>
                  <li>Login to sehyog.co.uk using your credentials</li>
                  <li>Go to 'My Students' and click on 'Student Listing' link there.</li>
                  <li>Use '<a href="https://www.sehyog.co.uk/elearning" target="_blank" class="pfaq-link--highlight">eLearning</a>' button available under Action Column on the right side pane.</li>
                  <li>Use 'Live Class' icon there to go to Live Meeting/Class – that's first icon on Top Left</li>
                  <li>You will see a YouTube like black window on next page – click on 3 parallel lines on Top Left corner</li>
                  <li>Select 'Meeting Links' from the drop down and then select the category from category drop down.</li>
                  <li>Your Batch Meeting Links will be displayed underneath category drop down – select correct batch Meeting Link if there are multiple Meeting Links.</li>
                  <li>Wait for Host to admit you in the meeting.</li>
                </ol>
              </div>
            </div>
          </div>

          <!-- Q11 -->
          <div class="pfaq-accordion__item">
            <a class="pfaq-accordion__trigger cursor" href="#pfaq11" data-toggle="collapse">
              <span class="pfaq-accordion__q">Q</span>
              <span class="pfaq-accordion__question">How to access Test, Assignments and Result/Score?</span>
              <i class="fa fa-angle-down pfaq-accordion__icon"></i>
            </a>
            <div id="pfaq11" class="pfaq-accordion__body content collapse">
              <div class="pfaq-accordion__answer">
                <ol>
                  <li>Login to sehyog.co.uk using your credentials</li>
                  <li>Go to 'My Students' and click on 'Student Listing' link there.</li>
                  <li>Use '<a href="https://www.sehyog.co.uk/elearning" target="_blank" class="pfaq-link--highlight">eLearning</a>' button available under Action Column on the right side pane.</li>
                  <li>Use 'Tests' icon there to access Tests &amp; Assignments</li>
                  <li>Use 'Score' icon to view the Result after you have successfully submitted the Test/Assignment.</li>
                </ol>
              </div>
            </div>
          </div>

        </div><!-- /accordion -->
      </div><!-- /content -->

    </div><!-- /container -->
  </section>

</div>